var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: { value: _vm.value, title: "Import Text Path", "hide-footer": "" },
      on: {
        input: function ($event) {
          return _setup.emit("input", $event)
        },
        closed: _setup.close,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "drop-zone",
          class: { "drag-over": _setup.isDraggingOver },
          on: {
            dragover: function ($event) {
              $event.preventDefault()
              _setup.isDraggingOver = true
            },
            dragleave: function ($event) {
              $event.preventDefault()
              _setup.isDraggingOver = false
            },
            drop: function ($event) {
              $event.preventDefault()
              return _setup.onDrop.apply(null, arguments)
            },
          },
        },
        [
          _c("span", [_vm._v("Drop an SVG file here or")]),
          _vm._v(" "),
          _c(_setup.CButton, {
            attrs: { text: "Choose file", variant: "secondary", size: "sm" },
            on: { click: _setup.openFilePicker },
          }),
          _vm._v(" "),
          _c("input", {
            ref: "fileInput",
            attrs: { type: "file", accept: ".svg,image/svg+xml", hidden: "" },
            on: { change: _setup.onFileSelected },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(_setup.CTextarea, {
        staticClass: "mt-3",
        attrs: {
          value: _setup.source,
          rows: 4,
          debounce: 0,
          label: "Or paste SVG code",
          placeholder:
            "<svg>…</svg> or a path like M 62 174 L 104 66 C 362 140 362 180 320 182",
          error: !!_setup.errorMsg,
          "error-msg": _setup.errorMsg,
        },
        on: { input: _setup.onSourceInput },
      }),
      _vm._v(" "),
      _setup.candidates.length
        ? [
            _c("label", { staticClass: "mt-3 mb-1" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _setup.candidates.length > 1
                      ? "Choose the path the text will follow"
                      : "Preview"
                  ) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "candidates" },
              _vm._l(_setup.candidates, function (candidate, index) {
                return _c(
                  "button",
                  {
                    key: index,
                    staticClass: "candidate",
                    class: { selected: index === _setup.selectedIndex },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _setup.selectedIndex = index
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: candidate.viewBox,
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: candidate.pathData,
                            "vector-effect": "non-scaling-stroke",
                          },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: {
                            cx: candidate.start.x,
                            cy: candidate.start.y,
                            r: candidate.size * 0.04,
                          },
                        }),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("small", { staticClass: "text-muted" }, [
              _vm._v("The dot marks where the text starts."),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-between custom-footer" },
        [
          _c(_setup.CButton, {
            attrs: { text: "Cancel", variant: "secondary" },
            on: { click: _setup.close },
          }),
          _vm._v(" "),
          _c(_setup.CButton, {
            attrs: {
              text: "Apply",
              variant: "primary",
              disabled: !_setup.selected,
            },
            on: { click: _setup.apply },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }